import { isDevMode } from '@angular/core';
import { ActionReducer, ActionReducerMap, MetaReducer } from '@ngrx/store';

import * as fromPackageDetail from '../components/package-detail/redux/reducers/package-detail.reducers';
import * as fromCities from './redux/reducers/cities.reducers';
import * as fromDestinations from './redux/reducers/destinations.reducers';
import * as fromHome from '../components/home/redux/reducers/home.reducers';
import * as fromAuth from '../reducers/redux/reducers/auth.reducer';
import * as fromPackageListings from '../components/package-listing/redux/reducers/package-listing.reducers';
import { PackageDetailEffects } from '../components/package-detail/redux/effects';
import { CitiesEffects } from './redux/effects';
import { DestinationsEffects } from './redux/effects'; // Updated import
import { HomeEffects } from '../components/home/redux/effects';
import { PackageListingEffects } from '../components/package-listing/redux/effects/package-listing.effects';
import {
  QuotesEffect,
  TripEffect,
} from '../components/users/trips/redux/effects';
import * as fromTrip from '../components/users/trips/redux/reducers/requested-trips.reducers';
import * as fromQuote from '../components/users/trips/redux/reducers/quotes.reducers';
import * as fromUsers from '../components/users/redux/reducers/users.reducers';
import { UserEffect } from '../components/users/redux/effects';
export interface State {
  auth: fromAuth.AuthState;
  packageDetail: fromPackageDetail.PackageDetailState;
  cities: fromCities.CitiesState;
  destinations: fromDestinations.DestinationsState;
  home: fromHome.HomeState;
  packageListings: fromPackageListings.PackageListingsState;
  trip: fromTrip.TripState;
  quote: fromQuote.QuoteState;
  users: fromUsers.UserState;
}

export const rootReducers: ActionReducerMap<State> = {
  auth: fromAuth.reducer,
  packageDetail: fromPackageDetail.reducer,
  cities: fromCities.reducer,
  destinations: fromDestinations.reducer,
  home: fromHome.reducer,
  packageListings: fromPackageListings.reducer,
  trip: fromTrip.reducer,
  quote: fromQuote.reducer,
  users: fromUsers.reducer,
};

// console.log all actions
export function debug(reducer: ActionReducer<State>): ActionReducer<State> {
  return function (state, action) {
    return reducer(state, action);
  };
}

export const metaReducers: MetaReducer<State>[] = isDevMode()
  ? [debug]
  : [debug];

export const appEffectsModules = [
  // define effects here
  PackageDetailEffects,
  CitiesEffects,
  DestinationsEffects,
  HomeEffects,
  PackageListingEffects,
  TripEffect,
  QuotesEffect,
  UserEffect,
];
